import { render, staticRenderFns } from "./detailsBargainAct.vue?vue&type=template&id=20947643&scoped=true&"
import script from "./detailsBargainAct.vue?vue&type=script&lang=js&"
export * from "./detailsBargainAct.vue?vue&type=script&lang=js&"
import style0 from "./detailsBargainAct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./detailsBargainAct.vue?vue&type=style&index=1&id=20947643&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20947643",
  null
  
)

component.options.__file = "detailsBargainAct.vue"
export default component.exports